import { createSelector } from 'reselect'
import { createSelector as ormCreateSelector } from 'redux-orm'
import orm from '../../models/models'

export const userFollowedPlaylists = createSelector(
  state => state.orm,
  state => state.users.currentUserUsername,
  ormCreateSelector(orm, (session, username) => {
    const currentUser = session.User.withId(username)
    return currentUser
      ? currentUser.playlists.orderBy('order').toModelArray()
      : []
  })
)

export const userAuthoredPlaylists = createSelector(
  state => state.orm,
  state => state.users.currentUserUsername,
  ormCreateSelector(orm, (session, username) => {
    const currentUser = session.User.withId(username)
    if (currentUser) {
      return currentUser.playlists
        .filter({
          author: { username: currentUser.getId() }
        })
        .orderBy('order')
        .toModelArray()
    } else {
      return []
    }
  })
)

export const playlists = createSelector(
  state => state.orm,
  ormCreateSelector(orm, session => session.Playlist.all().toModelArray())
)

export const playlistWithUUID = (state, uuid) => {
  const selector = createSelector(
    state => state.orm,
    ormCreateSelector(orm, session => session.Playlist.withId(uuid))
  )

  return selector(state)
}

export const getDisplayedPlaylist = createSelector(
  state => state.orm,
  state => state.ui.playlists.displayedPlaylistUUID,
  ormCreateSelector(orm, (session, uuid) => session.Playlist.withId(uuid))
)

export const displayedPlaylistEntries = createSelector(
  state => state.orm,
  state => state.ui.playlists.displayedPlaylistUUID,
  state => state.ui.playlists.entriesOrder,
  ormCreateSelector(orm, (session, uuid, entriesOrder) => {
    let displayedPlaylistEntries = session.PlaylistEntries.filter(
      entry => entry.playlist === uuid
    )
    if (!entriesOrder) {
      displayedPlaylistEntries = displayedPlaylistEntries.orderBy('orderBy')
    }
    return displayedPlaylistEntries.toModelArray().map(entry => ({
      id: entry.id,
      obj: entry.planEntry,
      createdAt: entry.createdAt
    }))
  })
)
